import baseFunction from 'hoist-non-react-statics'

function hoistNonReactStatics(Hoc, WrappedComponent) {
  if (WrappedComponent) {
    baseFunction(Hoc, WrappedComponent)
  }
}

export default hoistNonReactStatics
